import React from "react";
import Hackerman from "../asset/membuka-hasil-tabungan-freelance/hacker-man.jpg";
import Struktur from "../asset/membuka-hasil-tabungan-freelance/struktur.png";
import Tabungan from "../asset/membuka-hasil-tabungan-freelance/tabungan-freelance.png";

class MembukaHasilTabunganFreelance extends React.Component {
  render() {
    return (
      <>
        <div className="container pt-4 pb-4 content-detail">
          <div className="header pb-4">
            <h1 className="font-PoppinsBold">
              Membuka Hasil Tabungan{" "}
              <span className="font-green">Freelance 650 Jam</span> [Clickbait
              👻].
            </h1>
            <span className="font-PoppinsBold mx-1 text-grey">23-05-2025</span>
          </div>
          <div className="nav-content shadow-sm p-3 mb-5">
            <h2 className="font-PoppinsBold">Opening</h2>
            <p className="text text-justify">
              Halo selamat malam teman teman, saya ingin bercerita hasil dari
              freelance saya sebagai pentester selama 11 bulan ini, kegiatan ini
              saya lakukan selama -+ 11 bulan ini. Article ini saya tulis untuk
              memotivasi saya, mungkin teman teman agar lebih semangat dalam
              mencari rejeki walau harus rodi 🥶🥶.
            </p>
            <img
              src={Hackerman}
              className="img-fluid pb-1"
              alt="Responsive"
            />
            <h2 className="font-PoppinsBold">Content</h2>
            <p>
              Sebelumnya, saya bekerja sebagai Offensive Security, saya bekerja
              <b> 09.00-18.00 WIB</b>, kemudian saya melanjutkan freelance pada
              pukul
              <b> 19.00 - 23.30 WIB</b>, Dimana project saya dihitung 1 mandays
              dengan kurang lebih <b>4-5 jam</b> kerja.{" "}
              <b>650 Jam disini adalah 650 Jam / 5 Jam 1 hari</b>, yang mana
              rentang itu sekitar 11 bulan saya jalani. Sehingga kalau dirincikan
              kurang lebih timeline 11 bulan seperti berikut:
            </p>
            <ol>
              <li>Bulan ke 1-5 7 days kerja = 35 hari</li>
              <li>Bulan ke 6-7 10 days kerja = 20 hari</li>
              <li>Bulan ke 8 15 days kerja = 15 hari</li>
              <li>Bulan ke 9-11 20 days kerja = 60 hari</li>
              <li>Total = 130 hari x 5 jam = 650 Jam</li>
            </ol>
            <p className="pb-2">
              Peningkatan yang sangat berimpact dari bulan ke bulan, bahkan saya
              terkejut ketika sudah lama, tidak membuka tabungan freelance saya,
              impact 3 bulan terakhir meningkat cukup pesat.
            </p>
            <h2 className="font-PoppinsBold">Memulai Freelance</h2>
            <p className="pb-2">
              Teringat pertama kali start project kami, yang kami lakukan
              bukanlah membuka layanan pentest, kami justru melakukan forensic
              salah satu web client kami yang sering terkena deface, seiring
              berjalan waktu customer percaya dengan jasa kami. Mungkin memang
              sulit untuk memulai freelance terutama untuk mencari klien,
              kebetulan saya diberi kemudahan, Abang kelas saya memiliki partner
              di australi, market di australi sangat banyak membutuhkan jasa
              tersebut, sehingga saya menjadi partner abang kelas saya untuk
              meng-handle pentest tersebut.
            </p>
            <img
              src={Struktur}
              className="mx-auto pb-1 w-1/2 mb-2"
              alt="Responsive"
            />
            <p className="pb-2">
              ** Struktur freelance saya 🫡🫡.
              <b> lalu bagimana kami memberikan kepuasan pada client?</b>
              <br />
              <br />
              <ol>
                <li>
                  Kami memastikan feature yang ada berjalan dengan baik sebelum
                  jam kerja dimulai dengan tujuan tidak merugikan jam kerja yang
                  mereka bayar kekami.
                </li>
                <li>
                  Kami memberikan skenario gambaran test case terhadap aplikasi,
                  serta data provide yang diperlukan dengan tujuan tidak
                  menggangu client ketika jam kerja berjalan dan tidak menggangu
                  jam kerja yang dibayarkan.
                </li>
                <li>
                  Kami membatasi client yang kami handle, mungkin kami bisa
                  menjalani 2-3 client dalam Waktu bersamaan untuk quantity
                  keuntungan kami, tapi kami selalu membatasi dengan tujuan
                  kualitas menjadi hasil akhir kami.
                </li>
                <li>
                  Kami menjelaskan proof of concept secara detail, dengan sangat
                  jelas dan tertahta, bahkan kami juga memberikan layanan retest
                  finding sebelumnya jika diperlukan.{" "}
                </li>
              </ol>
              Back to topic, lalu berapa pendapatan yang saya dapatkan selama
              650 jam kerja? * disini saya hanya untuk sharing dan berbagi
              pengalaman saya*
            </p>
            <img
              src={Tabungan}
              style={{ width: "80%", height: "auto" }}
              alt="Responsive"
              className="mt-2 pb-2"
            />
            <p className="pb-2">
              ** Tebak sendiri depannya
              <br />
              Yap berikut tabungan yang saya dapat dari freelance 650 jam kerja
              kurang lebih 1 mandays (4-5 jam) menyesuaikan client base
              Australi/US. Apakah ini tabungan freelance saja? Iyap, saya selalu
              membagi 3 tabungan saya
            </p>
            <ol>
                <li>
                  Tabungan penerimaan gaji, (transit gaji) ke tabungan utama,
                  tabungan ini yang saya pakai untuk freelance.{" "}
                </li>
                <li>
                  Tabungan utama ( tabungan gaji, dan project lain yang
                  menghasilkan){" "}
                </li>
                <li>
                  Tabungan sehari hari, ini lebih tepatnya ewallet: gopay, untuk
                  beli barang, transaksi sehari hari, transfer hari hari, dan
                  jajan mejanjan, saya selalu menggunakan ini kalau kata temen
                  saya mr ilham tujuan manajemen uang, menurut saya pribadi sama
                  saja tinggal persepsi kalian mengatur dan mindset terhadap
                  uang, kalau saya pribadi lebih menjaga minimnya bersentuhan ke
                  rekening utama, seperti pembayar kasir, qris, suatu saat ada
                  publik exploitasi, (saya harap tidak) , namun yang saya expect
                  tidak langsung bersentuhan ke rekening utama, tapi cukup ke
                  wallet saya saja.{" "}
                </li>
              </ol>
              <h2 className="font-PoppinsBold">Closing</h2>
              <p className="pb-2">
              Dibalik freelance, saya pribadi masih merasakan kurangnya skillset, sehingga saya juga harus memotivasi diri saya membagi waktu dalam Fokus belajar, tapi saya juga banyak belajar diantaranya:
              </p>
              <ol>
                <li>
                  Saya belajar menempatkan diri sebagai pentester dengan client yang bersifat individu
                </li>
                <li>
                Saya belajar membuat test case keperluan pentest saya
                </li>
                <li>Saya belajar membuat keputusan</li>
                <li>Saya belajar bahasa Inggris, walaupun kena koreksi terus inggris saya 🤣🤣
                </li>
                <li>Dan last but not least mengatur timeline, memanfaatkan waktu istirahat. Miss sedikit berimpact pada aktivas saya besok. 
                </li>
              </ol>
              <p className="pb-2">
              mungkin next artikel saya tertarik untuk menulis, aplikasi unik yang saya pentest dan aplikasi yang keren mungkin akan ada di Indonesia 2/3 tahun lagi, serta finding menarik yang saya temukan. 
              <b> sekian, maaf kalau ada salah kata, terimakasih sudah membaca.</b>
              </p>
          </div>
        </div>
      </>
    );
  }
}

export default MembukaHasilTabunganFreelance;
